import makeStyles from '@material-ui/core/styles/makeStyles';
import i18n from 'locales/i18n';

const getDefaultFont = () => {
  const direction = i18n.dir()
  const poppins = ['Poppins', 'Roboto', 'Open Sans', 'sans-serif'].join(',')
  const notoSansArabic = ['NotoSansArabic', 'Roboto', 'Open Sans', 'sans-serif'].join(',')
  return direction === "rtl" ? notoSansArabic: poppins
}

export const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: "515px",
    fontFamily: getDefaultFont(),
    width: '100%',
    paddingTop: 10,
    [theme.breakpoints.up('lg')]: {
      paddingTop: 30,
    },

  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    "& label": {
      fontSize: 23,
    }
  },
  saveButton: {
    borderRadius: 5,
    width: 200,
  },
  cancelButton: {
    color: theme.palette.common.black,
    borderRadius: 5,
    fontWeight: 500,
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 15,
    [theme.breakpoints.up('lg')]: {
      paddingTop: 34,
    },
  },
}));
